__webpack_require__.p = "/capybara-chat-front/";